module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-c701dbed587b79c42402b82abfc5feee.jpg";